/* eslint-disable no-console -- intentional DevTools easter egg */



/**

 * One %c block. Few line breaks so DevTools does not paint as many separate navy stripes.

 * Copy is short; no blank lines in the string.

 */



const CARD =

  'display:inline-block;' +

  'max-width:480px;' +

  'margin:8px 0;' +

  'padding:14px 18px;' +

  'background:#0F335B;' +

  'background-image:linear-gradient(180deg,rgba(255,255,255,0.05) 0%,transparent 55%);' +

  'color:#EEF4F8;' +

  'font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;' +

  'font-size:12px;' +

  'line-height:1.45;' +

  'text-align:left;' +

  'border-radius:12px;' +

  'border:1px solid rgba(89,157,167,0.4);' +

  'box-shadow:0 2px 0 rgba(255,255,255,0.04) inset,0 6px 20px rgba(0,0,0,0.28);' +

  'white-space:pre-wrap;' +

  '-webkit-box-decoration-break:slice;' +

  'box-decoration-break:slice;';



const MESSAGE =

  'FIELDPORTER · VOLUNTAS\n' +

  'Welcome to the Voluntas console.\n' +

  'Glad you are looking. Feedback and bug reports both help. Reach out anytime. Freddy and the team are glad to help.\n' +

  'https://fieldporter.com';



export function logDevConsoleGreeting(): void {

  if (typeof console === 'undefined' || typeof console.log !== 'function') {

    return;

  }



  console.log('%c' + MESSAGE, CARD);

}


